import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { CheckinCommonStoreService } from '@common/services/checkin-common-store/checkin-common-store.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CheckinCommonClearGuard implements CanActivate {
  constructor(private CheckinCommonStroeService: CheckinCommonStoreService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // このガードを通った際には、チェックイン共通の以下の値を削除する
    this.CheckinCommonStroeService.updateCheckinCommon({
      isSkipCheckinSeatmap: undefined,
      isSkipCheckinPassengerInput: undefined,
    });

    return true;
  }
}
